// import courierRoute from './courier'
import defaultRoute from './default'

// 是否小哥直赔
const isGsp = location.href.indexOf('gsp') > -1 || location.href.indexOf('courier') > -1

function mockToken() {
  const isLocal = location.href.indexOf('localhost') > -1
  if (isLocal && isGsp) {
    window.nativeBridge = {
      sgsApp_getSGSToken: () => {
        return '{"data":{"token":"123"}}'
      },
      sgsApp_getUserInfo: () => {
        return '{"data": {"userName": "guojian", "fullName": "abc"}}'
      },
    }
  }
}

mockToken()

const router = defaultRoute

export default router
// 3、创建登录组件
// 4、指定出口
